import { render } from "./CustomButton.vue?vue&type=template&id=7e241fcf"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=7e241fcf&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__